// extracted by mini-css-extract-plugin
export default {"btn":"MButton_btn__apPB4","saleBtn":"MButton_saleBtn__yYzHI"};